import { LoginData, LoginResponse } from "../types/auth";
import { APP_CONFIG } from "../constants";
import { apiClient } from "./apiClient";

export const authService = {
  fetchScreenPermissions: async (): Promise<string[]> => {
    const data = await apiClient.get<{ allowedScreenKeys: string[] }>(
      "/auth/screen-permissions"
    );
    return data.allowedScreenKeys ?? [];
  },

  login: async (data: LoginData): Promise<LoginResponse> => {
    const response = await fetch(`${APP_CONFIG.API_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data.email,
        senha: data.password,
      }),
    });

    if (!response.ok) {
      throw new Error("Falha na autenticação");
    }

    return response.json();
  },
};
